<script>
import {
  pageInfosEtServicesPageContenuProps,
  usePageInfosEtServicesPageContenu
} from "./mixin";
import CmsContainer from "@/components/organisms/cms-container";
import { useContextStore } from "@/store/context";
import { mapState } from "pinia";

export default {
  name: "PageContenu",
  scrollToTop: true,
  components: {
    CmsContainer
  },
  props: {
    ...pageInfosEtServicesPageContenuProps()
  },
  setup(props) {
    const { isDisplayModeAppli } = useContextStore();
    const { title, updated } = usePageInfosEtServicesPageContenu(props);

    onUpdated(updated);
    return { title, isDisplayModeAppli };
  },
  computed: {
    ...mapState(useContextStore, ["displayMode"]),
    mainClasses() {
      if (this.displayMode) {
        return "u-bgcolor-white u-p-md";
      }
      return "u-bgcolor-white u-ml-md u-mr-md u-mb-md u-mt-sm u-m-none@sm u-p-md u-radius-md u-radius-none@sm";
    }
  }
};
</script>

<template>
  <div>
    <div :class="mainClasses">
      <CmsContainer
        v-if="cmsReponse && cmsReponse.data && cmsReponse.data.attributes"
        :contents="cmsReponse.data.attributes.contents"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/styles/globals/cms.scss";
</style>
